var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('benefit-list-item');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ContentNode } from './content-node';
import { useEntity } from '../../hooks/use-entity';
export var BenefitListItemDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0;\n    margin: 0 0 ", " 0;\n  "], ["\n    padding: 0;\n    margin: 0 0 ", " 0;\n  "])), theme.UNIT(6))
});
var TitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n    font-weight: 500;\n    margin-bottom: 0.5em;\n  "], ["\n    font-size: 1em;\n    font-weight: 500;\n    margin-bottom: 0.5em;\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 1em;\n  "], ["\n    font-weight: 300;\n    font-size: 1em;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.li(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled.h3.attrs(cls.attr('title'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: styled(ContentNode)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles)
};
export var BenefitListItem = function BenefitListItem(props) {
  var className = props.className,
      children = props.children;
  var entity = useEntity(props.entity);
  var title = entity.title,
      name = entity.name,
      description = entity.description;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Title, null, title || name), React.createElement(My.Description, {
    entity: description
  }));
};
BenefitListItem.defaultProps = BenefitListItemDefaultProps;
BenefitListItem.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;